export default __webpack_public_path__ + "static/media/K420_SOV.6526b3c1.pdf";